module.exports = __webpack_public_path__ + "static/media/loan_appli_w.3be068ce.svg";